import { track } from '@adsk/acs-web-analytics';
import {
  ENTITLEMENTS_PLATFORM_TYPES,
  EntitlementsProject,
} from '@adsk/alloy-provider';

import { HQAccount } from '../models';
import { isACCPlatform } from '../utils';

export type TrackRowClickProps = {
  analyticName: string;
  selectedProject?: EntitlementsProject;
  accountsUserIsAccAccountAdmin: HQAccount[];
};

export function trackRowClick({
  analyticName,
  selectedProject,
  accountsUserIsAccAccountAdmin,
}: TrackRowClickProps) {
  if (!selectedProject) {
    return;
  }

  const platform = isACCPlatform(selectedProject.platform)
    ? ENTITLEMENTS_PLATFORM_TYPES.ACC
    : ENTITLEMENTS_PLATFORM_TYPES.BIM360;

  track(analyticName, {
    platform,
    is_account_admin_on_project: !!accountsUserIsAccAccountAdmin.find(
      (account) => selectedProject.accountId === account.id,
    ),
  });
}
